import { MapDataItem } from '@bpd-library/types';

import { INCLUDED_PROPERTIES } from '../extended-api-models/included-properties';
import {
    ApartmentBuildingModel,
    AreaProjectModel,
    AreaStatus,
    ConstructionNumberModel,
    DistrictModel,
    ProjectPhaseModel,
    ProjectPhaseStatus,
    PropertyTypeModel,
} from '../generated';

type PropertyTypeStatus =
    | 'InPreparation'
    | 'SaleSoon'
    | 'SaleStarted'
    | 'AssigningOn'
    | 'AmountAvailable'
    | 'InOption'
    | 'Sold'
    | 'UnderConstruction'
    | 'ForRent'
    | 'Rented';

type ApartmentBuildingStatus =
    | 'InPreparation'
    | 'SaleSoon'
    | 'SaleStarted'
    | 'AssigningOn'
    | 'AmountAvailable'
    | 'Available'
    | 'ForRent'
    | 'InOption'
    | 'Sold'
    | 'Rented'
    | 'UnderConstruction';

type GeneratedConstructionNumberStatus =
    | 'InPreparation'
    | 'InOption'
    | 'Available'
    | 'AssigningOn'
    | 'Sold'
    | 'Rented'
    | 'Reserved'
    | 'UnderConstruction';

interface ExtendedConstructionNumber
    extends Pick<
        ConstructionNumberModel,
        'id' | typeof INCLUDED_PROPERTIES.constructionNumber[number]
    > {
    areaProject?: ExtendedAreaProject;
    propertyType?: ExtendedPropertyType;
    projectPhase?: ExtendedProjectPhase;
    mapDataItems?: MapDataItem[];
    apartmentBuilding?: ExtendedApartmentBuilding;
    status?: GeneratedConstructionNumberStatus;
    objectType: 'constructionNumber';
}

interface ExtendedPropertyType
    extends Pick<PropertyTypeModel, 'id' | typeof INCLUDED_PROPERTIES.propertyType[number]> {
    constructionNumbers?: ExtendedConstructionNumber[];
    projectPhase?: ExtendedProjectPhase;
    mapDataItems?: MapDataItem[];
    status?: PropertyTypeStatus;
    apartmentBuildings?: ExtendedApartmentBuilding[];
    objectType: 'propertyType';
}

interface ExtendedProjectPhase
    extends Pick<ProjectPhaseModel, 'id' | typeof INCLUDED_PROPERTIES.projectPhase[number]> {
    constructionNumbers?: ExtendedConstructionNumber[];
    propertyTypes?: ExtendedPropertyType[];
    mapDataItems?: MapDataItem[];
    objectType: 'projectPhase';
}

interface ExtendedApartmentBuilding
    extends Pick<
        ApartmentBuildingModel,
        'id' | typeof INCLUDED_PROPERTIES.apartmentBuilding[number]
    > {
    constructionNumbers?: ExtendedConstructionNumber[];
    propertyTypes?: ExtendedPropertyType[];
    projectPhase?: ExtendedProjectPhase;
    mapDataItems?: MapDataItem[];
    status?: ApartmentBuildingStatus;
    objectType: 'apartmentBuilding';
}

interface ExtendedDistrict
    extends Pick<DistrictModel, 'id' | typeof INCLUDED_PROPERTIES.district[number]> {
    status?: ProjectPhaseStatus;
    mapDataItems?: MapDataItem[];
    objectType: 'district';
}

interface ExtendedAreaProject
    extends Pick<AreaProjectModel, 'id' | typeof INCLUDED_PROPERTIES.areaProject[number]> {
    status?: AreaStatus;
    mapDataItems?: MapDataItem[];
    objectType: 'areaProject';
}

type ExtendedApiObject =
    | ExtendedConstructionNumber
    | ExtendedApartmentBuilding
    | ExtendedPropertyType
    | ExtendedProjectPhase
    | ExtendedDistrict
    | ExtendedAreaProject;

export {
    ExtendedConstructionNumber,
    ExtendedPropertyType,
    ExtendedApartmentBuilding,
    ExtendedProjectPhase,
    ExtendedDistrict,
    ExtendedAreaProject,
    ExtendedApiObject,
    PropertyTypeStatus,
    ApartmentBuildingStatus,
    GeneratedConstructionNumberStatus,
};
